export default __webpack_public_path__ + "static/media/icon_redaria.ee4be3d2.png";